import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { getIsHotelOnly } from 'src/store/view/selectors';
import { openRoomPopupAction } from '../../store/actions/room-popup';
import {
  getIsRoomInfoAvailable,
  getPackageId,
} from '../../store/selectors/package';
import AboutRoomButton from './AboutRoomButton';

const mapStateToProps = (state) => ({
  packageId: getPackageId(state),
  isHotelOnly: getIsHotelOnly(state),
  hasInfo: getIsRoomInfoAvailable(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClick: (packageId) => dispatch(openRoomPopupAction(packageId)),
});
const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(AboutRoomButton);
